export * from './search-svg-path-pipe.module';
